import React from "react";
import ReactPaginate from "react-paginate";

import "./Paginator.scss";

interface PaginatorProps {
  onChange?: (selectedItem: { selected: number }) => void;
  // Required by ReactPaginate (pageCount is a required prop there); the
  // component always receives it from callers.
  pageCount: number;
  page?: number;
}

const Paginator = ({ onChange, pageCount, page }: PaginatorProps) => {
  return (
    <div className="paginator">
      <ReactPaginate
        previousLabel={"Prev"}
        nextLabel={"Next"}
        breakLabel={"..."}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={onChange}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        containerClassName={"pagination"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        activeClassName={"active"}
        forcePage={page}
      />
    </div>
  );
};

export default Paginator;
